import styled, { css } from "styled-components";
import { colorsPalettes } from "@similarweb/styles";

const closedOffset = 5;
const wrapperHoverBehavior = css`
    translate: 0;
    clip-path: inset(0 0 0 0);
`;

export const SideTabWrapper = styled.div<{
    sideOffset?: number;
    verticalOffset?: number;
    isDragged?: boolean;
}>`
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    right: ${({ sideOffset }) => sideOffset ?? 0}px;
    top: 50%;
    bottom: 50%;
    min-width: 120px;
    width: auto;
    height: 36px;
    border-radius: 18px 18px 0 0;
    border: 1px ${colorsPalettes.blue[400]};
    border-style: solid solid none solid;
    clip-path: inset(0 0 ${closedOffset}px 0);
    transform-origin: bottom right;
    translate: ${closedOffset}px 0;
    transition: 0.2s;
    transform: rotate(-90deg) translateX(75%) translateX(${({ verticalOffset }) => verticalOffset ?? 0}px);

    &:hover {
        ${wrapperHoverBehavior}
    }

    ${({ isDragged }) =>
        isDragged &&
        `
        ${wrapperHoverBehavior}
        opacity: .5;
    `}
    @media print {
        display: none;
    }
`;

export const SideTabContentContainer = styled.div``;
